import { render, staticRenderFns } from "./ExchangeTypeComponent.vue?vue&type=template&id=84024256&scoped=true&"
import script from "./ExchangeTypeComponent.vue?vue&type=script&lang=js&"
export * from "./ExchangeTypeComponent.vue?vue&type=script&lang=js&"
import style0 from "./ExchangeTypeComponent.vue?vue&type=style&index=0&id=84024256&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84024256",
  null
  
)

component.options.__file = "ExchangeTypeComponent.vue"
export default component.exports